import React from "react";
import { Dropdown, IDropdownOption } from "@fluentui/react";
import { PaymentTermType } from "../../api-clients/api";
import { useTranslation } from "react-i18next";

interface IProps {
  onChange: (
    event: React.FormEvent<HTMLDivElement>,
    option?: IDropdownOption,
    index?: number
  ) => void;
  multiSelect: boolean;
  selectedKeys: string[] | number[] | null;
  selectedKey?: string | number | string[] | number[] | null;
  label?: string;
  placeholder?: string;
  required: boolean;
}
export default function PaymentTermDropdown(props: IProps) {
  const { t } = useTranslation();
  const options: any[] = [
    {
      key: PaymentTermType._1,
      text: t("shared.paymentTermExchangeLetter"),
    },
    {
      key: PaymentTermType._2,
      text: t("shared.paymentTermCash"),
    },
    {
      key: PaymentTermType._3,
      text: t("shared.paymentTermTransfer"),
    },
    {
      key: PaymentTermType._4,
      text: t("shared.paymentTermDeposit"),
    },
    {
      key: PaymentTermType._5,
      text: t("shared.paymentTermCheck"),
    },
    {
      key: PaymentTermType._6,
      text: t("shared.paymentTermOther"),
    },
  ];

  return <Dropdown {...props} options={options} style={{ width: "100%" }} />;
}

PaymentTermDropdown.defaultProps = {
  multiSelect: false,
  selectedKeys: null,
  selectedKey: null,
  label: null,
  placeholder: null,
  required: false,
};
